import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class WorkshopStepsOrganizations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'WorkshopStepsOrganizations'
  // Define default properties here
  static instanceDefaults () {
    return {
      organizationId: null,
      workshopStepId: null,
    }
  }
}
const servicePath = 'workshop-steps-organizations'
const servicePlugin = makeServicePlugin({
  Model: WorkshopStepsOrganizations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
